export class UserSettings {
    blackCalendarIcon: boolean = false
    typeaheadNom: boolean = false
    surveyQuestionsSeparatePage: boolean = false
}
